import React from "react";
import { speedCounts } from "./geotabDashboard.js";
import { fmtDelta } from "./geotabFormat.js";
import GeotabDriverPerformanceDetail from "./GeotabDriverPerformanceDetail.jsx";

// Onglet Rapidité de la fiche du chauffeur : route, chargement et livraison comparés aux collègues, en %.
const METRICS = [["route", "Route", "trajets"], ["loading", "Chargement", "visites"], ["delivery", "Livraison", "visites"]];
// Arrondi avant le signe : −0,3 % s'affiche « 0 % », sans flèche.
const pctText = (value) => { const r = Math.round(value); return `${r > 0 ? "+" : r < 0 ? "−" : ""}${Math.abs(r)} %`; };

export default function GeotabDriverSpeed({ driver, row, data }) {
  const [detail, setDetail] = React.useState(null);
  return (
    <section aria-label={`Rapidité de ${row.name}`}>
      <p className="mb-1.5 mt-0 text-[11.5px] text-slate-600">
        Route : temps réel / prévu comparé aux autres chauffeurs, sans les pauses. Chargement et livraison : écart au prévu comparé à celui des collègues aux mêmes endroits, en médiane et en % du prévu.
      </p>
      <div className="grid gap-2 [grid-template-columns:repeat(auto-fit,minmax(min(240px,100%),1fr))]">
        {METRICS.map(([metric, label, unit]) => {
          const s = row.speed?.[metric];
          const measure = driver?.performance?.[metric] || {};
          const color = !s ? "#cbd5e1" : !row.regular || !speedCounts(metric, s) ? "#94a3b8" : s.pct > 0 ? "#c5524a" : "#0f5c57";
          const reach = metric === "route" ? 30 : 50;
          const offset = s ? (Math.max(-reach, Math.min(reach, s.pct)) / reach) * 50 : 0;
          return (
            <section key={metric} className="rounded-[4px] border border-slate-200 px-3 py-2">
              <h3 className="m-0 text-[10.5px] font-bold uppercase tracking-wide text-slate-600">{label}</h3>
              <p className="my-0.5 text-[24px] font-bold tabular-nums" style={{ color }}>
                {s ? `${Math.round(s.pct) > 0 ? "▲ " : Math.round(s.pct) < 0 ? "▼ " : ""}${pctText(s.pct)}` : "—"}
                {s?.minutes != null && <span className="ml-2 text-[12px] font-semibold text-slate-600">{`${fmtDelta(s.minutes)} par visite`}</span>}
              </p>
              <div aria-hidden="true" className="relative mb-0.5 mt-1.5 h-2 rounded-[2px] bg-slate-100">
                <span className="absolute -bottom-[3px] -top-[3px] left-1/2 w-px bg-slate-600" />
                {s && <i className="absolute inset-y-0" style={{ background: color, left: `${offset < 0 ? 50 + offset : 50}%`, width: `${Math.abs(offset)}%` }} />}
              </div>
              <div className="flex justify-between text-[10px] text-slate-500"><span>plus rapide</span><span>collègues</span><span>plus lent</span></div>
              <p className="mb-1 mt-1.5 text-[11px] text-slate-600">{s ? `${measure.days} jours · ${measure.count} ${unit} comparables` : "Comparaison indisponible : référence des collègues insuffisante."}</p>
              <button type="button" onClick={() => setDetail(metric)}
                className="border-0 bg-transparent p-0 text-[11.5px] font-bold text-accent underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40">
                Voir le calcul complet
              </button>
            </section>
          );
        })}
      </div>
      {detail && driver && <GeotabDriverPerformanceDetail driver={driver} data={data} initialMetric={detail} onClose={() => setDetail(null)} />}
    </section>
  );
}
